// isTypingTarget — the shared "is the keydown coming from a text-entry surface we
// must not hijack?" predicate. Native fields, contenteditable, plus code editors
// (CM6 / Monaco) whose focused element isn't itself a textarea. Extracted so the
// process ⌘K hook (useCommandPaletteHotkey) and the global hotkey registry share
// ONE definition — a global hotkey must never fire while the user is typing.

/** True when the event originates from a text-entry surface we must not hijack. */
export function isTypingTarget(t: EventTarget | null): boolean {
  const el = t as HTMLElement | null;
  if (!el || !el.tagName) return false;
  if (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable === true) return true;
  return typeof el.closest === "function" && el.closest(".cm-editor, .monaco-editor") !== null;
}
